import { FileAsset } from '@inference.engine/api-client';
import type { FileAssetWithUrl } from '../../model/chats.types';

/* eslint-disable i18next/no-literal-string -- file upload status values */
export const FileStatus = {
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  FAILED: 'failed',
  REFERENCED: 'referenced',
} as const;
/* eslint-enable i18next/no-literal-string */

export type FileStatusType = (typeof FileStatus)[keyof typeof FileStatus];

interface FileAssetMetadata {
  fileName: string;
  size?: number;
}

export interface FileInputWithStatus extends FileAsset {
  status: FileStatusType;
  file: File;
  url: string;
  metadata: FileAssetMetadata;
  abortController?: AbortController;
  /**
   * Insertion order shared with project-context items so the composer renders a
   * single append-at-the-end attachment list. Stamped when first added;
   * preserved when the upload completes.
   */
  addedAt?: number;
}

export interface UseFileAttachmentsProps {
  getModelFromContext?: () => string | undefined;
}

export interface UseFileAttachmentsReturn {
  files: FileInputWithStatus[];
  isUploading: boolean;
  handleFileUpload: (files: File[]) => Promise<void>;
  handleInputFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  handleFileReference: (file: FileAssetWithUrl) => void;
  handleRemoveFile: (assetId: string) => void;
  clearFiles: () => void;
}
